import React from 'react';

import filterTokens from '@amzn/meridian-tokens/base/icon/filter';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Tooltip from '@amzn/meridian/tooltip';

const toggleFilterButton = (props: {
  'aria-label': string;
  onClick: () => void;
  tooltipTitle?: Tooltip['props']['title'];
  tooltipPlacement?: Tooltip['props']['position'];
  'data-testid'?: string;
}) => {
  const { ['aria-label']: ariaLabel, tooltipTitle, tooltipPlacement, onClick, ['data-testid']: dataTestId } = props;

  const button = (
    <Button type="icon" aria-label={ariaLabel} data-testid={dataTestId} onClick={onClick}>
      <Icon tokens={filterTokens} />
    </Button>
  );

  if (!tooltipTitle) {
    return button;
  }

  return (
    <Tooltip position={tooltipPlacement ?? 'top'} title={tooltipTitle}>
      {button}
    </Tooltip>
  );
};

export default toggleFilterButton;
